import React from 'react';
import './loader.css'

const Loading = ({ text, style }) => {
    return (
        <div className="loading-container" style={style}>
            <div className="spinner"></div>
            {text && <p>{text}</p>}
        </div>
    );
};

export default Loading;
